import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { useQuery } from '@tanstack/react-query'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import AssetListItem from '@/modules/admin/cost-objects/CostObjectDetails/Profile/AssetListItem'
import queries from '@/modules/admin/queries'
import adminResources from '@/modules/admin/resources'

import './AssetsSneakPeek.styles.scss'

const AssetsSneakPeek: FC<{ costObjectId: number; onGoToAssetTab: () => void }> = ({
  costObjectId,
}) => {
  const [, setQueryTab] = useSearchParamsByKey('tab')

  const { data, isLoading } = useQuery(queries.adminAssetList({ allAssets: true }), () =>
    adminResources.getAssetListWithFilters({ allAssets: true })
  )

  if (!data) return null

  const itemsFiltered =
    data?.assets.filter(asset => asset.costObjectId === Number(costObjectId)) || []

  const shortenedList = itemsFiltered.slice(0, 2)
  const numberOfRemainingAssets = itemsFiltered.length - 2

  if (isLoading) return <LoaderCircle />

  return (
    <div className="profile-assets">
      <h3>
        <Translation id="Assets" />
      </h3>

      {shortenedList.length > 0 ? (
        <div className="sneak-peek-asset-list">
          {shortenedList.map(item => (
            <AssetListItem key={item.id} searchFilter="" {...item} />
          ))}

          {numberOfRemainingAssets > 0 && (
            <div className="remaining-assets">
              <Button variant="tertiary" className="m-0 p-0" onClick={() => setQueryTab('assets')}>
                <div className="more-assets">
                  <div>
                    <Translation
                      id="{numberOfRemainingAssets} more"
                      numberOfRemainingAssets={String(numberOfRemainingAssets)}
                      className="more-assets-text"
                    />
                  </div>
                  <div>
                    <ChevronRightIcon />
                  </div>
                </div>
              </Button>
            </div>
          )}
        </div>
      ) : (
        <NoResults />
      )}
    </div>
  )
}

export default AssetsSneakPeek
